<template>
  <div class="project_list">
    <div class="project-layer" v-for="(project,projectIndex) in list" @click="tapProject(project)">
      <div class="img-layer">
        <img v-lazy="project.banner_imgurl" />
      </div>
      <div class="bottom-layer">
        <div class="title">{{project.extinfo.buildingName}}</div>
        <div class="price">{{project.extinfo.unitPrice}}</div>
        <div class="more">查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
const Visitors = () => import("@/components/visitors_pro");
export default {
  components: {
    Visitors
  },
  props: {
    list: Array
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapState(["userInfo", "receiveSpreadInfo", "isInMiniProgram"])
  },
  methods: {
    // lj02
    tapProject(item) {
      if (item.h5PageUrlHttps || item.click_url) {
        let url = item.click_url ? item.click_url : item.h5PageUrlHttps;
        if (item.click_url) {
          //跳转后走静默授权
          url += "&authtype=silence";
        }
        if (location.href.indexOf("/t9_project") > -1) {
          url += `&topfrom=t9_project`;
        }
        util.openYqRsMakeLink(url);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}

.project_list {
}

.project_list .project-layer {
  margin-bottom: 0.24rem;
  position: relative;
}

.project_list .project-layer .img-layer {
  height: 4rem;
  width: 100%;
}

.project_list .project-layer .img-layer > img {
  display: block;
  width: 100%;
  max-height: 4rem;
  min-height: 4rem;
  object-fit: cover;
}

.project_list .project-layer .bottom-layer {
  position: relative;
}

.project_list .project-layer .bottom-layer .title {
  height: p2r(34px);
  font-size: p2r(36px);
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(12, 12, 12, 1);
  line-height: p2r(36px);
  padding-top: p2r(29px);
}

.project_list .project-layer .bottom-layer .price {
  height: p2r(27px);
  font-size: p2r(28px);
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(190, 47, 44, 1);
  line-height: p2r(36px);
  padding-top: p2r(20px);
}

.project_list .project-layer .bottom-layer .more {
  position: absolute;
  right: p2r(10px);
  top: p2r(29px);
  font-size: p2r(22px);
  font-family: PingFang SC;
  color: rgba(153, 153, 153, 1);
}
</style>